import React from "react";
import {
  Dimensions,
  I18nManager,
  Platform,
  StyleSheet,
  View,
  TouchableOpacity,
} from "react-native";

import { Ionicons } from "@expo/vector-icons";
import Color, { Transparent, WHITE, White } from "react-native-material-color";
import * as Constants from "../utils/Constants";

const width = Math.max(Dimensions.get("window").width, Constants.MIN_WIDTH);
const height = Dimensions.get("window").height;

// const drawerIconImg = require('../images/drawer_icon.png');

export const isLtr = () => !I18nManager.isRTL;
const isMobile = Dimensions.get("window").width < Constants.MIN_WIDTH;

export const renderSeparator = (w) => <View style={{ width: w }} />;
export const renderVSeparator = (h) => <View style={{ height: h }} />;
export const fontFamily1 = "Satoshi-Regular";
export const fontFamily2 = "Satoshi-Regular";
export const fontFamily3 = "Satoshi-Regular";
export const fontFamily4 = "Satoshi-Regular";

// Helper function to get proper font family for React Native based on weight
export const getSatoshiFont = (weight = 400) => {
  // if (Platform.OS === 'web') {
  //   return "Satoshi";
  // }

  switch (weight) {
    case 500:
    case "500":
    case "medium":
      return "Satoshi-Medium";
    case 700:
    case "700":
    case "bold":
      return "Satoshi-Bold";
    case 400:
    case "400":
    case "normal":
    default:
      return "Satoshi-Regular";
  }
};

export const appColor1 = "#3B627F";
export const appColor2 = "#3B627F";
export const appColor3 = '#808080';
export const appColor4 = Transparent;
export const fontSize1 = isMobile ? 36 : 45;
export const fontSize2 = isMobile ? 14 : 16;
export const fontSize3 = isMobile ? 24 : 28;
export const fontSize4 = isMobile ? 16 : 16;
export const fontSize5 = isMobile ? 20 : 22.5;

export const contactUsButtonHovered = {
  ...TextStyle2,
  fontSize: width / 87.5,
  letterSpacing: 1.25,
  color: WHITE
}

export const contactUsButton = {
  ...TextStyle2,
  color: appColor1,
  letterSpacing: 1.25,
  fontSize: width / 87.5,
}

export const TextStyle1 = {
  fontFamily: getSatoshiFont(400),
  color: appColor1,
  fontSize: fontSize1,
  fontWeight: Platform.OS === 'web' ? 400 : 'normal',
  lineHeight: fontSize1 * 1.2
}

export const TextStyle2 = {
  fontFamily: getSatoshiFont(400),
  color: appColor2,
  fontSize: fontSize2,
  lineHeight: fontSize2 * 1.6,
}

export const TextStyle3 = {
  fontFamily: getSatoshiFont(400),
  color: appColor1,
  fontSize: fontSize3,
  fontWeight: Platform.OS === 'web' ? 400 : 'normal',
  lineHeight: fontSize3 * 1.2
}

export const TextStyle4 = {
  fontFamily: getSatoshiFont(400),
  color: appColor3,
  fontSize: fontSize4,
  fontWeight: Platform.OS === 'web' ? 400 : 'normal',
  lineHeight: fontSize4 * 1.6
}


export const TextStyle5 = {
  height: 56,
  width: 352,
  // borderBottomWidth:1,
  borderBottomColor: appColor1,
  lineHeight: fontSize5 * 1.6,
  fontFamily: fontFamily2,
  color: appColor1,
  fontSize: 22.5,
}

export const TextStyle6 = {
  fontFamily: fontFamily2,
  color: appColor3,
  fontSize: fontSize4,
  fontWeight: '400',
  lineHeight: fontSize4 * 1.6,
}

export const TextStyle2Hovered = {
  fontFamily: fontFamily2,
  color: appColor2,
  fontSize: fontSize2,
  color: "#52c0ee",
  // textDecorationLine: 'underline'
}


export const FooterTextStyle = {
  fontFamily: fontFamily2,
  color: appColor2,
  fontSize: 12,
  color: "#C6C6C6"
}

export const FooterTextStyleHovered = {
  fontFamily: fontFamily2,
  fontSize: 12,
  color: appColor2
}

export const OurHistoryImageStyle = {
  height: 10,
  width: 10,
}

export const OurHistoryStyle = {
  fontWeight: '400',
  textAlign: 'center',
  fontSize: fontSize4,
  lineHeight: fontSize4 * 1.6,
  color: appColor3,
}

export const ButtonStyle = {
  border: `1.5px solid`,
  borderRadius: 20,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
}

export const ButtonStyleCareer = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  width: isMobile ? 370 : undefined,
  alignItems: isMobile ? 'center' : undefined
}

export const buttonStyleCareer2 = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  width: isMobile ? 390 : undefined,
  alignItems: isMobile ? 'center' : undefined
}


export const ButtonApplyNow = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  width: 130,
}

export const ButtonStyle2 = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  justifyContent: 'center',
  alignItems: 'center',
}

export const historyButtonStyle = {
  height: 15,
  width: 15,
  borderRadius: 100,
  backgroundColor: '#52c0ee',
}

export const historyButtonStylePressed = {
  height: 15,
  width: 15,
  borderRadius: 100,
  backgroundColor: appColor3,
}

export const ContactUsSubmitButton = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: '#C6C6C6',
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  justifyContent: 'center',
  alignItems: 'center',
}

export const GetInTouchButton = {
  border: `1.5px solid`,
  borderRadius: 40,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  justifyContent: 'center',
  alignItems: 'center',
}

export const GetInTouchHoveredButton = {
  border: '1px solid transparent',
  borderRadius: 40,
  paddingHorizontal: 24,
  paddingVertical: 14,
  backgroundColor: "#52c0ee",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  justifyContent: 'center',
  alignItems: 'center',
}

export const ButtonStyleHovered = {
  border: '1px solid transparent',
  borderRadius: 20,
  paddingHorizontal: 24,
  paddingVertical: 14,
  backgroundColor: "#52c0ee",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
}

export const ButtonStyleCareerHovered = {
  ...ButtonStyle,
  border: '1px solid transparent',
  borderRadius: 40,
  paddingHorizontal: 24,
  paddingVertical: 14,
  backgroundColor: "#52c0ee",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
}

export const ButtonApplyNowHovered = {
  ...ButtonStyle,
  border: '1px solid transparent',
  borderRadius: 40,
  paddingHorizontal: 24,
  paddingVertical: 14,
  backgroundColor: "#52c0ee",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  width: 130,
}

export const ButtonStyleHoveredService = {
  ...ButtonStyle,
  border: '1px solid transparent',
  borderRadius: 50,
  paddingHorizontal: 24,
  paddingVertical: 14,
  backgroundColor: "#52c0ee",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
}

export const ButtonStyleService = {
  ...ButtonStyle,
  border: `1.5px solid`,
  borderRadius: 50,
  borderColor: appColor1,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
}


export const ButtonStyleSubmit = {
  ...ButtonStyle,
  border: `1.5px solid`,
  borderRadius: 20,
  borderColor: appColor3,
  paddingHorizontal: 24,
  paddingVertical: 14,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
}

export const SubmitButtonTextStyle = {
  ...TextStyle2,
  color: '#C6C6C6',
  letterSpacing: 1.25,
  fontSize: 15
}

export const ButtonTextStyle = {
  ...TextStyle2,
  letterSpacing: 1.25,
  fontSize: 15
}

export const ButtonTextStyleHovered = {
  ...TextStyle2,
  letterSpacing: 1.25,
  fontSize: 15,
  color: WHITE,
}

export const ButtonSubmitTextStyleHovered = {
  ...TextStyle2,
  letterSpacing: 1.25,
  fontSize: 16,
  color: WHITE
}

export const CareerButtonHovered = {
  // ...TextStyle2,
  // letterSpacing: "1.25px",
  fontSize: width / 93.33,
  color: WHITE
}

export const CareerButtonStyle = {
  // ...TextStyle2,
  // letterSpacing: "1.25px",
  fontSize: width / 93.33,
}


export const leftNavView = {
  flexDirection: "row",
  alignItems: "center",
  marginLeft: 12,
};

export const dateTextInput = {
  fontFamily: "riposte",
  fontSize: 12,
  padding: 10,
  color: "#6b3529",
  width: 55,
  backgroundColor: "#f2f2f2",
  textAlign: "center",
  borderWidth: 0,
  marginRight: 15
};

export const leftNavBtn = {
  marginHorizontal: 12,
  color: Constants.appColor,
};

export const btnsView = {
  marginBottom: 18,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

export const btn = {
  backgroundColor: Constants.appColor,
  width: width / 2 - 28,
  justifyContent: "center",
};

export const fab = (size) => ({
  overflow: "hidden",
  borderWidth: 1,
  height: size,
  width: size,
  borderRadius: size / 2,
  alignItems: "center",
  justifyContent: "center",
  shadowColor: "#000000",
  shadowOpacity: 0.8,
  shadowRadius: 2,
});

export const shadow = {
  borderTopWidth: 0,
  elevation: 8,
  shadowColor: "#000000",
  shadowOpacity: 0.8,
  shadowRadius: 2,
  shadowOffset: {
    height: 2,
    width: 0,
  },
};

export const badge = (size) => [
  fab(size),
  { position: 'absolute', top: -5, right: -5, backgroundColor: White, color: '#6b3529', borderRadius: 10, borderColor: 'transparent' }
];

export const brownBadge = (size) => [
  // fab(size),
  // { position: 'absolute', bottom: -8, left: -5, backgroundColor: '#6b3529', borderColor: 'transparent' }
];

export const badgeText = {
  fontSize: 11,
  color: "#6b3529",
  overflow: "hidden",
  backgroundColor: "transparent",
};

export const fillAbsolute = {
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  position: "absolute",
};

export const appBackground = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "115%",
  height: "105%",
};

export const btnText = {
  fontSize: 18,
  color: "white",
  padding: 12,
  overflow: "hidden",
  backgroundColor: "transparent",
};
export const modalStyle = {
  // height: height - 50,
  // paddingVertical: 0,
  zIndex: 1000,
  padding: 12,
  borderRadius: 6,
  alignItems: "center",
  backgroundColor: "blue",
  position: "absolute",
  bottom: 10,
};

export const modal = {
  height: -1,
  width: width - 48,
  maxWidth: 700,
  backgroundColor: Color.GREY[100],
  padding: 12,
  marginBottom: 24,
  borderRadius: 6,
  marginTop: -50,
  alignItems: "center",
  marginLeft: isLtr() ? 0 : 48,
  alignSelf: isLtr() ? null : "center",
};

export const fullModal = {
  height: height - 25,
  width: width,
  backgroundColor: Color.GREY[100],
  // alignItems: 'center',
  // alignSelf: isLtr() ? null : 'center'
};

export const orderAvatar = {
  width: 42,
  height: 42,
  borderRadius: 21,
};

export const modalView = {
  width: modal.width - 24,
  maxWidth: 700,
  alignItems: "flex-start",
  justifyContent: "center",
  padding: 20,
};

export const fullModalView = {
  marginTop: 12,
  width: width,
  alignItems: "center",
};

export const border = {
  borderWidth: StyleSheet.hairlineWidth,
  borderColor: Color.GREY[500],
  borderRadius: 4,
};

export const modalInput = {
  width: modal.width - 24,
  maxWidth: 700 - 40,
  textAlign: isLtr() ? "left" : "right",
  padding: 8,
  fontSize: 16,
  color: "black",
  ...border,
  borderWidth: 0,
  borderBottomWidth: StyleSheet.hairlineWidth,
};

export const modalBoxInput = {
  ...modalInput,
  borderWidth: StyleSheet.hairlineWidth,
};

export const bottomTxtView = {
  //flex: 1,
  backgroundColor: Constants.appColor,
  alignItems: "center",
  justifyContent: "center",
  padding: 6,
};

export const orderModalDeliveryTimeView = {
  width,
  flexDirection: "row",
  padding: 12,
  alignItems: "center",
  justifyContent: "flex-start",
  borderColor: Color.GREY[500],
};

export const promoCode = {
  ...modalInput,
  width: modal.width,
  borderWidth: StyleSheet.hairlineWidth,
  borderColor: "#6b3529",
  fontFamily: "riposte",
  color: "#6b3529",
};

export const orderModalBottomTxtView = {
  flexDirection: "row",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: 50,
  alignItems: "center",
  justifyContent: "center",
};

export const bottomTxt = {
  fontSize: 18,
  color: "white",
  width: "80%",
  textAlign: "center",
  marginBottom: Platform.select({ ios: 2 }),
};

export const bottomTxt2 = {
  fontSize: 18,
  color: "white",
  width: "100%",
  textAlign: "center",
  marginBottom: Platform.select({ ios: 2 }),
};

export const orderNote = {
  ...modalInput,
  width: modal.width,
  borderWidth: StyleSheet.hairlineWidth,
  borderColor: "#6b3529",
  fontFamily: "riposte",
  color: "#6b3529",
};

export const boxInput = {
  ...modalBoxInput,
  width: modal.width,
};

export const lightInput = {
  textAlign: isLtr() ? "left" : "right",
  padding: 12,
  fontSize: 17,
  color: "black",
  backgroundColor: Color.GREY[100],
  borderRadius: 4,
};

export const modalInputTitle = {
  fontSize: 14,
  color: Color.GREY[900],
  textAlign: "left",
  alignSelf: "flex-start",
  marginLeft: 2,
  fontFamily: "riposte",
  color: "#6b3529",
};

export const modalBtnsView = {
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "center",
  alignSelf: "flex-end",
  padding: Platform.select({ android: 8 }),
};

export const closeModalIcon = {
  position: "absolute",
  top: 0,
  left: 12,
  padding: 12,
  overflow: "hidden",
  backgroundColor: "transparent",
};

export const closeSmallModalIcon = {
  position: "absolute",
  right: 0,
  padding: 8,
};

export const logo = {
  alignSelf: "center",
  resizeMode: Platform.OS === "android" ? "contain" : "cover",
  height: Platform.OS === "android" ? 150 : 100,
  width: width * 0.7,
  position: "relative",
  borderRadius: Platform.OS === "android" ? 32 : 16,
  marginTop: Platform.OS === "android" ? 0 : 42,
  marginBottom: Platform.OS === "android" ? 0 : 24,
};

export const splashLogo = {
  alignSelf: "center",
  resizeMode: Platform.OS === "android" ? "contain" : "cover",
  height: Platform.OS === "android" ? width * 0.7 * 0.78 : width * 0.55 * 0.78,
  width: Platform.OS === "android" ? width * 0.7 : width * 0.55,
  position: "relative",
  marginTop: Platform.OS === "android" ? -32 : 0,
  borderRadius: Platform.OS === "android" ? 32 : 16,
  marginBottom: 24,
};

export const splashTitle = {
  alignSelf: "center",
  resizeMode: Platform.OS === "android" ? "contain" : "cover",
  height: 300 / 7,
  width: 300,
  position: "relative",
  borderWidth: StyleSheet.hairlineWidth,
  borderColor: Color.GREY[900],
  borderRadius: 8,
  overflow: "hidden",
  marginBottom: 24,
  marginTop: Platform.OS === "android" ? -18 : 6,
};

export const rightNavView = {
  flexDirection: "row",
  alignItems: "center",
  marginRight: 8,
};

export const rightNavBtn = {
  marginHorizontal: 12,
};

export const drawerIcon = {
  marginLeft: Platform.OS === "ios" ? 12 : 12,
  marginRight: 12,
  paddingHorizontal: Platform.OS === "android" ? 8 : 8,
  paddingVertical: Platform.OS === "android" ? 4 : 2,
  paddingTop: Platform.OS === "android" ? 4 : 4,
  overflow: "hidden",
  backgroundColor: "transparent",
};

export const drawerButton = (navigation) => (
  <TouchableOpacity
    style={[
      drawerIcon,
      { flexDirection: "row", alignItems: "center", justifyContent: "center" },
    ]}
    onPress={() => navigation.openDrawer()}
  >
    <Ionicons name="md-menu" size={32} color="white" style={{ marginTop: 4 }} />
  </TouchableOpacity>
);

export const drawerButtonDark = (navigation) => (
  <TouchableOpacity
    style={[
      drawerIcon,
      { flexDirection: "row", alignItems: "center", justifyContent: "center" },
    ]}
    onPress={() => navigation.openDrawer()}
  >
    <Ionicons
      name="md-menu"
      size={32}
      color="#6b3529"
      style={{ marginTop: 4 }}
    />
  </TouchableOpacity>
);

export const backButton = (props) => {
  return (
    <TouchableOpacity
      style={drawerIcon}
      onPress={() => {
        try {
          props.close();
        } catch (err) {
          props();
        }
      }}
    >
      <Ionicons name="md-arrow-back" size={24} color="#6b3529" />
    </TouchableOpacity>
  );
};

export const searchBarView = {
  padding: 8,
  marginHorizontal: 12,
  marginTop: 12,
  elevation: 2,
  marginBottom: 2,
  backgroundColor: "white",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.3,
  shadowRadius: 2,
};

export const searchTI = {
  textAlign: "left",
  flex: 0.9,
  marginHorizontal: 8,
  fontSize: 16,
};

export const searchIcon = {
  flex: 0.05,
  marginHorizontal: 8,
  color: Color.GREY[700],
};

export const clearIcon = {
  flex: 0.05,
  position: "absolute",
  right: 16,
  color: Color.GREY[600],
};

export const modalTitle = {
  fontSize: 18,
  paddingLeft: 2,
  paddingBottom: 12,
  fontFamily: "riposte",
  color: "#6b3529",
};

export const itemRowView = {
  padding: 4,
  width: modal.width,
  borderBottomWidth: StyleSheet.hairlineWidth,
  borderColor: "#6b3529",
  flexDirection: "row",
  justifyContent: "space-between",
};

export const subItemRowView = {
  flexDirection: "row",
  alignItems: "center",
};

export const subItemText = {
  fontSize: 18,
  fontFamily: "zarid",
  color: "#6b3529",
};

export const bottomView = {
  flexDirection: "row",
  padding: 12,
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "white",
  alignItems: "center",
  justifyContent: "center",
  borderTopWidth: StyleSheet.hairlineWidth,
  borderColor: Color.GREY[500],
};

export const bottomBtn = {
  width: width / 2.75,
  backgroundColor: Constants.appColor,
  padding: 12,
  alignItems: "center",
  justifyContent: "center",
};

export const bottomBtnText = {
  color: "white",
  fontSize: 16,
};

export const bottomBorder = {
  borderBottomWidth: StyleSheet.hairlineWidth,
  borderColor: Color.GREY[500],
};

export const subContainerSmall = {
  maxWidth: 500,
  width: width,
};

export const subContainerMedium = {
  maxWidth: 800,
  width: width,
  flex: 1,
};
